export enum GranTypeEnum {
	refresh_token = 'refresh_token',
	sso = 'sso',
	portfolio = 'portfolio',
}
